import { BasePersistedConfig } from "../../../../utils/BasePersistedConfig";
import {
  assignOnBeforeCompileDataAndFunction,
  OnBeforeCompileDataConverter
} from "./OnBeforeCompile";
export class MaterialPersistedConfig extends BasePersistedConfig {
  constructor(node) {
    super(node);
    this.node = node;
  }
  toJSON() {
    const assemblerController = this.node.assemblerController();
    if (!assemblerController) {
      return;
    }
    const assembler = assemblerController.assembler;
    const onBeforeCompileData = assembler.onBeforeCompileData();
    if (!onBeforeCompileData) {
      return;
    }
    const onBeforeCompileDataJSON = OnBeforeCompileDataConverter.toJSON(onBeforeCompileData);
    const customMaterialsData = {};
    const customMaterials = this.node.material.customMaterials;
    if (customMaterials) {
      assembler.traverseCustomAssemblers((customAssembler, customMaterialName) => {
        const customOnBeforeCompileData = customAssembler.onBeforeCompileData();
        if (customOnBeforeCompileData) {
          const customMaterial = customMaterials[customMaterialName];
          if (customMaterial) {
            const customMaterialData = this._materialToJson(customMaterial, {
              node: this.node,
              suffix: customMaterialName
            });
            if (customMaterialData) {
              customMaterialsData[customMaterialName] = {
                material: customMaterialData,
                onBeforeCompileDataJSON: OnBeforeCompileDataConverter.toJSON(customOnBeforeCompileData)
              };
            }
          }
        }
      });
    }
    const materialData = this._materialToJson(this.node.material, {
      node: this.node,
      suffix: "main"
    });
    if (!materialData) {
      console.warn("failed to save material from node", this.node.path());
    }
    const data = {
      material: materialData || {},
      onBeforeCompileDataJSON,
      customMaterials: customMaterialsData
    };
    return data;
  }
  load(data) {
    const assemblerController = this.node.assemblerController();
    if (assemblerController) {
      return;
    }
    this._material = this._loadMaterial(data.material);
    if (!this._material) {
      return;
    }
    const onBeforeCompileData = OnBeforeCompileDataConverter.fromJSON(data.onBeforeCompileDataJSON);
    const material = this._material;
    assignOnBeforeCompileDataAndFunction(this.node.scene(), material, onBeforeCompileData);
    for (let paramConfig of onBeforeCompileData.paramConfigs) {
      paramConfig.applyToNode(this.node);
    }
    this._material.customMaterials = this._material.customMaterials || {};
    if (data.customMaterials) {
      const customMatNames = Object.keys(data.customMaterials);
      for (let customMatName of customMatNames) {
        const customMatData = data.customMaterials[customMatName];
        const customMat = this._loadMaterial(customMatData.material);
        if (customMat) {
          const customOnBeforeCompileData = OnBeforeCompileDataConverter.fromJSON(customMatData.onBeforeCompileDataJSON);
          customOnBeforeCompileData.paramConfigs = onBeforeCompileData.paramConfigs;
          assignOnBeforeCompileDataAndFunction(this.node.scene(), customMat, customOnBeforeCompileData);
          this._material.customMaterials[customMatName] = customMat;
        }
      }
    }
  }
  material() {
    return this._material;
  }
}
